import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "row mx-n2" }
const _hoisted_2 = { class: "card with-actiondropdown px-0 overflow-hidden h-100" }
const _hoisted_3 = {
  key: 0,
  class: "file-actions"
}
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" }, null, -1)
const _hoisted_6 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit mr-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-archive mr-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-archive mr-2" }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "file-actions"
}
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_15 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fa fa-regular fa-thumbtack" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-regular fa-thumbtack" }, null, -1)
const _hoisted_20 = { class: "hovered-div" }
const _hoisted_21 = { class: "card-header-wrap pl-3" }
const _hoisted_22 = { class: "project-header" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "type-holder dark-grey-tag" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fa fa-archive mr-1" }, null, -1)
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "type-holder dark-grey-tag" }
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fa fa-archive mr-1" }, null, -1)
const _hoisted_29 = {
  key: 2,
  class: "card-title"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_31 = {
  key: 3,
  class: "user-role-wrap"
}
const _hoisted_32 = { class: "text-muted fs-12" }
const _hoisted_33 = {
  key: 4,
  class: "user-role-wrap"
}
const _hoisted_34 = { class: "text-muted fs-12" }
const _hoisted_35 = {
  key: 5,
  class: "user-role-wrap"
}
const _hoisted_36 = { class: "text-muted fs-12" }
const _hoisted_37 = {
  key: 6,
  class: "user-role-wrap"
}
const _hoisted_38 = { class: "text-muted fs-12" }
const _hoisted_39 = {
  key: 7,
  class: "user-role-wrap"
}
const _hoisted_40 = { class: "text-muted fs-12" }
const _hoisted_41 = { class: "card-body-wrap custom-scroll-box" }
const _hoisted_42 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_43 = {
  key: 1,
  class: "location"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)
const _hoisted_45 = { class: "px-3" }
const _hoisted_46 = { class: "dashed-bordered-card mt-2 py-3 px-2" }
const _hoisted_47 = { class: "project-body" }
const _hoisted_48 = { class: "row mb-3 align-items-center no-gutters" }
const _hoisted_49 = { class: "col-6 col-sm-6 col-md-8 col-lg-8 col-xl-6" }
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments text-green" }, null, -1)
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 0,
  class: "col-6 col-sm-6 col-md-6 col-lg-4 col-xl-6 text-right"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)
const _hoisted_55 = { class: "bg-light p-2 rounded" }
const _hoisted_56 = {
  key: 0,
  class: "chat-inline-list"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createTextVNode()
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { class: "link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane" })
], -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 1,
  class: "text-center mt-3"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_63 = {
  key: 2,
  class: "members-list pt-0"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "more-member" }
const _hoisted_67 = { class: "modal-wrap default-modal" }
const _hoisted_68 = { class: "custom-modal-overlay" }
const _hoisted_69 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_70 = { class: "modal-content" }
const _hoisted_71 = { class: "modal-header" }
const _hoisted_72 = { class: "d-block" }
const _hoisted_73 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_74 = { class: "text-muted" }
const _hoisted_75 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_76 = { class: "modal-body" }
const _hoisted_77 = { class: "form-wrap pt-0" }
const _hoisted_78 = { class: "form-group" }
const _hoisted_79 = { for: "exampleInputEmail1" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = { for: "exampleInputEmail1" }
const _hoisted_83 = {
  key: 0,
  class: "form-group"
}
const _hoisted_84 = {
  key: 1,
  class: "form-group bg-light border p-3 rounded"
}
const _hoisted_85 = { class: "mb-0" }
const _hoisted_86 = /*#__PURE__*/_createVNode("i", {
  title: "click on check box to include the given user in this channel",
  class: "fa fa-info-circle text-green"
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_88 = { class: "inline-items" }
const _hoisted_89 = { class: "custom-control custom-checkbox mb-3" }
const _hoisted_90 = { class: "modal-footer" }
const _hoisted_91 = { class: "modal-wrap default-modal" }
const _hoisted_92 = { class: "custom-modal-overlay" }
const _hoisted_93 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-height":"90vh","display":"flex","flex-direction":"column"}
}
const _hoisted_94 = {
  class: "modal-content",
  style: {"overflow":"hidden","display":"flex","flex-direction":"column","height":"100%","max-height":"90vh"}
}
const _hoisted_95 = { class: "modal-header" }
const _hoisted_96 = {
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_97 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_98 = {
  class: "modal-body",
  style: {"overflow-y":"auto","flex-grow":"1","min-height":"0","padding":"1rem"}
}
const _hoisted_99 = { class: "mb-3" }
const _hoisted_100 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "(*)", -1)
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = { for: "exampleInputEmail1" }
const _hoisted_103 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = { for: "exampleInputEmail1" }
const _hoisted_106 = { class: "form-group" }
const _hoisted_107 = { for: "exampleInputEmail1" }
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = { for: "projectAddress" }
const _hoisted_110 = { class: "modal-footer" }
const _hoisted_111 = { class: "modal-wrap default-modal" }
const _hoisted_112 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_113 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_114 = { class: "modal-content" }
const _hoisted_115 = { class: "modal-header" }
const _hoisted_116 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_117 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_118 = { class: "modal-body" }
const _hoisted_119 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_120 = { class: "modal-footer" }
const _hoisted_121 = { class: "modal-wrap default-modal" }
const _hoisted_122 = {
  class: "modal fade",
  id: "restoreModal",
  tabindex: "-1",
  "aria-labelledby": "restoreModalLabel",
  "aria-hidden": "true"
}
const _hoisted_123 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_124 = { class: "modal-content" }
const _hoisted_125 = { class: "modal-header" }
const _hoisted_126 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_127 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_128 = { class: "modal-body" }
const _hoisted_129 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_130 = { class: "modal-footer" }
const _hoisted_131 = { class: "modal-wrap default-modal" }
const _hoisted_132 = { class: "custom-modal-overlay" }
const _hoisted_133 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_134 = { class: "modal-content" }
const _hoisted_135 = { class: "modal-header" }
const _hoisted_136 = {
  class: "modal-title",
  id: "addFavPojectLabel"
}
const _hoisted_137 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_138 = { class: "modal-body" }
const _hoisted_139 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_140 = { class: "modal-footer" }
const _hoisted_141 = { class: "modal-wrap default-modal" }
const _hoisted_142 = { class: "custom-modal-overlay" }
const _hoisted_143 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_144 = { class: "modal-content" }
const _hoisted_145 = { class: "modal-header" }
const _hoisted_146 = {
  class: "modal-title",
  id: "removeFavPojectLabel"
}
const _hoisted_147 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_148 = { class: "modal-body" }
const _hoisted_149 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_150 = { class: "modal-footer" }
const _hoisted_151 = { class: "modal-wrap default-modal" }
const _hoisted_152 = { class: "custom-modal-overlay" }
const _hoisted_153 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_154 = { class: "modal-content" }
const _hoisted_155 = { class: "modal-header" }
const _hoisted_156 = {
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_157 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_158 = { class: "modal-body" }
const _hoisted_159 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_160 = { class: "modal-footer" }
const _hoisted_161 = { class: "modal-wrap default-modal" }
const _hoisted_162 = { class: "custom-modal-overlay" }
const _hoisted_163 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_164 = { class: "modal-content" }
const _hoisted_165 = { class: "modal-header" }
const _hoisted_166 = {
  class: "modal-title",
  id: "showPojectLabel"
}
const _hoisted_167 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_168 = { class: "modal-body" }
const _hoisted_169 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_170 = { class: "modal-footer" }
const _hoisted_171 = { class: "modal-wrap default-modal" }
const _hoisted_172 = {
  class: "modal fade",
  id: "showLocation",
  tabindex: "-1",
  "aria-labelledby": "showPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_173 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_174 = { class: "modal-content" }
const _hoisted_175 = { class: "modal-header" }
const _hoisted_176 = {
  class: "modal-title",
  id: "showPojectLabel"
}
const _hoisted_177 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_178 = { class: "modal-body" }
const _hoisted_179 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_GoogleMapView = _resolveComponent("GoogleMapView")
  const _component_GoogleMap = _resolveComponent("GoogleMap")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ShowMemberListModal = _resolveComponent("ShowMemberListModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectList, (project, projectIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: "col-lg-6 col-sm-6 px-2 mb-3",
            key: projectIndex
          }, [
            _createVNode("div", _hoisted_2, [
              (project.project_role.level === 1)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      _createVNode("a", {
                        class: "dropdown-toggle",
                        type: "button",
                        id: "dropdownMenuButton",
                        "data-toggle": "dropdown",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.threeDot && _ctx.threeDot(...args))),
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }, [
                        _hoisted_5
                      ]),
                      _createVNode("div", _hoisted_6, [
                        (project.status_id === 1)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.renameProjectModal(project)),
                                style: {"cursor":"pointer"}
                              }, [
                                _hoisted_7,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.selectedProjectArchive(project)),
                                style: {"cursor":"pointer"}
                              }, [
                                _hoisted_8,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('archive')), 1)
                              ], 8, ["onClick"]),
                              (project.visible && project.visible.length)
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.showProjectShow(project)),
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _hoisted_9,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('show')), 1)
                                  ], 8, ["onClick"]))
                                : (_openBlock(), _createBlock("a", {
                                    key: 1,
                                    class: "dropdown-item",
                                    onClick: ($event: any) => (_ctx.hideProjectShow(project)),
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _hoisted_10,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('hide')), 1)
                                  ], 8, ["onClick"]))
                            ], 64))
                          : _createCommentVNode("", true),
                        (project.status_id === 2)
                          ? (_openBlock(), _createBlock("a", {
                              key: 1,
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.selectedProjectRestore(project)),
                              style: {"cursor":"pointer"}
                            }, [
                              _hoisted_11,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('restore')), 1)
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : (!project.deleted_at && project.project_role.level != 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode("div", _hoisted_15, [
                          (project.visible && project.visible.length)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.showProjectShow(project))
                              }, [
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('show')), 1)
                              ], 8, ["onClick"]))
                            : (_openBlock(), _createBlock("a", {
                                key: 1,
                                class: "dropdown-item",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.hideProjectShow(project))
                              }, [
                                _hoisted_17,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('hide')), 1)
                              ], 8, ["onClick"]))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
              (project.favs && project.favs.length)
                ? (_openBlock(), _createBlock("span", {
                    key: 2,
                    class: "pin-tag pinned",
                    onClick: ($event: any) => (_ctx.removeFavProjectShow(project)),
                    title: "Unpin"
                  }, [
                    _hoisted_18
                  ], 8, ["onClick"]))
                : (_openBlock(), _createBlock("span", {
                    key: 3,
                    class: "pin-tag",
                    onClick: ($event: any) => (_ctx.addFavProjectShow(project)),
                    title: "Pin to top"
                  }, [
                    _hoisted_19
                  ], 8, ["onClick"])),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    (project.status_id === 2)
                      ? (_openBlock(), _createBlock("div", _hoisted_23, [
                          _createVNode("span", _hoisted_24, [
                            _hoisted_25,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('archived')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (project.deleted_at)
                      ? (_openBlock(), _createBlock("div", _hoisted_26, [
                          _createVNode("span", _hoisted_27, [
                            _hoisted_28,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('archived')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (project.name)
                      ? (_openBlock(), _createBlock("h3", _hoisted_29, [
                          _createVNode(_component_router_link, {
                            to: {
                    name: 'admin-project-details',
                    params: { projectId: project.uuid },
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('project')) + " : " + _toDisplayString(project.name) + " ", 1),
                              _hoisted_30
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (project.project_role.code === 'owner')
                      ? (_openBlock(), _createBlock("div", _hoisted_31, [
                          _createVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('your_role')) + " : " + _toDisplayString(project.project_role.name), 1)
                        ]))
                      : (project.project_role.code === 'user')
                        ? (_openBlock(), _createBlock("div", _hoisted_33, [
                            _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('your_role')) + " : " + _toDisplayString(project.project_role.name), 1)
                          ]))
                        : (project.project_role.code === 'todo_subcontractor' || project.project_role.code === 'todo_member' || project.project_role.code === 'todo_payer')
                          ? (_openBlock(), _createBlock("div", _hoisted_35, [
                              _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('your_role')) + " : " + _toDisplayString(project.project_role.name), 1)
                            ]))
                          : (project.project_role.code === 'shared_member')
                            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                                _createVNode("p", _hoisted_38, _toDisplayString(_ctx.$t('your_role')) + " : " + _toDisplayString(project.project_role.name), 1)
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_39, [
                                _createVNode("p", _hoisted_40, _toDisplayString(_ctx.$t('your_role')) + " : " + _toDisplayString(project.project_role.name), 1)
                              ]))
                  ])
                ]),
                _createVNode("div", _hoisted_41, [
                  (project.description)
                    ? (_openBlock(), _createBlock("p", _hoisted_42, _toDisplayString(project.description), 1))
                    : _createCommentVNode("", true),
                  (project.full_address)
                    ? (_openBlock(), _createBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode("p", null, _toDisplayString(project.full_address), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, [
                      _createVNode("div", _hoisted_49, [
                        _createVNode("h5", _hoisted_50, [
                          _hoisted_51,
                          _createTextVNode(_toDisplayString(_ctx.$t('chat_channels')), 1),
                          (project.channels && project.channels.length)
                            ? (_openBlock(), _createBlock("span", _hoisted_52, " (" + _toDisplayString(project.channels.length) + ")", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (project.project_role && project.project_role.level)
                        ? (_openBlock(), _createBlock("div", _hoisted_53, [
                            (!(project.deleted_at ||project.status_id === 2) && project.project_role.level === 1
                    )
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0)",
                                  class: "d-block create-url",
                                  onClick: ($event: any) => (_ctx.showCreateChannel(project)),
                                  id: project.id + 'newChannel'
                                }, [
                                  _hoisted_54,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('create_channel')), 1)
                                ], 8, ["onClick", "id"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_55, [
                      (project.channels && project.channels.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_56, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(project.channels.slice(0, 3), (channel, channelIndex) => {
                                return (_openBlock(), _createBlock("li", {
                                  class: "mr-2",
                                  key: channelIndex
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
                          name: 'admin-channel',
                          params: { channelId: channel.uuid},
                          query: { projectStatus: project.status_id }
                        }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode("button", {
                                        class: "chat-bubble-btn",
                                        ref: "myButton",
                                        "data-toggle": "tooltip",
                                        "data-placement": "top",
                                        "data-custom-class": "chat-bubble-tooltip",
                                        title: channel.name
                                      }, [
                                        _createTextVNode(_toDisplayString(_ctx.truncate(
                              channel.name, 30)) + " ", 1),
                                        (channel.notification_count)
                                          ? (_openBlock(), _createBlock("span", _hoisted_57, "(" + _toDisplayString(channel.notification_count) + ")", 1))
                                          : _createCommentVNode("", true),
                                        _hoisted_58,
                                        _hoisted_59
                                      ], 8, ["title"])
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128)),
                              (project.channels && project.channels.length > 3)
                                ? (_openBlock(), _createBlock("li", _hoisted_60, [
                                    _createVNode(_component_router_link, {
                                      title: "view more channels",
                                      to: {
                          name: 'admin-project-details',
                          params: { projectId: project.uuid },
                        },
                                      class: "view-more-btn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('view_more')) + " (" + _toDisplayString(project.channels.length - 3) + "+)", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_61, [
                            _createVNode("p", null, _toDisplayString(_ctx.$t('no_channel_yet')), 1)
                          ])),
                      _hoisted_62,
                      (project.members && project.members.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_63, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(project.members.slice(0, 3), (member, memberIndex) => {
                              return (_openBlock(), _createBlock("a", {
                                href: "javascript:void(0)",
                                key: memberIndex,
                                onClick: ($event: any) => (_ctx.allMembers(project))
                              }, [
                                (!project.deleted_at && !member.deleted_at)
                                  ? (_openBlock(), _createBlock("span", _hoisted_64, [
                                      (member.image)
                                        ? (_openBlock(), _createBlock("img", {
                                            key: 0,
                                            src: member.image,
                                            alt: "",
                                            title: `${member.full_name}` +
                          '(' +
                          `${member.email}` +
                          ')'
                          
                                          }, null, 8, ["src", "title"]))
                                        : (_openBlock(), _createBlock("img", {
                                            key: 1,
                                            src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg'
                          ,
                                            alt: "",
                                            title: `${member.full_name}` +
                            '(' +
                            `${member.email}` +
                            ')'
                            
                                          }, null, 8, ["src", "title"]))
                                    ]))
                                  : (project.deleted_at)
                                    ? (_openBlock(), _createBlock("span", _hoisted_65, [
                                        (member.image)
                                          ? (_openBlock(), _createBlock("img", {
                                              key: 0,
                                              src: member.image,
                                              alt: "",
                                              title: `${member.full_name}` +
                          '(' +
                          `${member.email}` +
                          ')'
                          
                                            }, null, 8, ["src", "title"]))
                                          : (_openBlock(), _createBlock("img", {
                                              key: 1,
                                              src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg'
                          ,
                                              alt: "",
                                              title: `${member.full_name}` +
                            '(' +
                            `${member.email}` +
                            ')'
                            
                                            }, null, 8, ["src", "title"]))
                                      ]))
                                    : _createCommentVNode("", true)
                              ], 8, ["onClick"]))
                            }), 128)),
                            (project.members.length > 3)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (_ctx.allMembers(project))
                                }, [
                                  _createVNode("span", _hoisted_66, "+" + _toDisplayString(project.members.length - 3), 1)
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      _withDirectives(_createVNode("div", _hoisted_67, [
        _createVNode("div", _hoisted_68, [
          _createVNode("div", _hoisted_69, [
            _createVNode("div", _hoisted_70, [
              _createVNode("div", _hoisted_71, [
                _createVNode("div", _hoisted_72, [
                  _createVNode("h5", _hoisted_73, _toDisplayString(_ctx.$t('create_channel')), 1),
                  _createVNode("p", _hoisted_74, _toDisplayString(_ctx.$t('channels_team_communication')), 1)
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideCreateChannel && _ctx.hideCreateChannel(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_75
                ])
              ]),
              _createVNode("div", _hoisted_76, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.error.errorList,
                  hasError: _ctx.state.ui.error.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                _createVNode("div", _hoisted_77, [
                  _createVNode("div", _hoisted_78, [
                    _createVNode("label", _hoisted_79, [
                      _createTextVNode(_toDisplayString(_ctx.$t('channel_name')) + " ", 1),
                      _hoisted_80
                    ]),
                    _withDirectives(_createVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "exampleInputEmail1",
                      "aria-describedby": "emailHelp",
                      placeholder: _ctx.$t('example_kitchen_modeling_team'),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.createChannel.name = $event))
                    }, null, 8, ["placeholder"]), [
                      [_vModelText, _ctx.state.data.createChannel.name]
                    ])
                  ]),
                  _createVNode("div", _hoisted_81, [
                    _createVNode("label", _hoisted_82, _toDisplayString(_ctx.$t('description')), 1),
                    _withDirectives(_createVNode("textarea", {
                      class: "form-control",
                      name: "",
                      id: "",
                      cols: "30",
                      rows: "10",
                      placeholder: _ctx.$t('channel_description'),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.createChannel.description = $event))
                    }, null, 8, ["placeholder"]), [
                      [_vModelText, _ctx.state.data.createChannel.description]
                    ])
                  ]),
                  (_ctx.state.coOwner && _ctx.state.coOwner.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_83, [
                        _createVNode("label", null, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.isIcludeCoOwner = $event)),
                            value: true
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.state.isIcludeCoOwner]
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('include_co_owner')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.isIcludeCoOwner)
                    ? (_openBlock(), _createBlock("div", _hoisted_84, [
                        _createVNode("label", _hoisted_85, [
                          _createTextVNode(_toDisplayString(_ctx.$t('co_owner_list')) + " ", 1),
                          _hoisted_86
                        ]),
                        _hoisted_87,
                        _createVNode("div", _hoisted_88, [
                          _createVNode("ul", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.coOwner, (co, coIndex) => {
                              return (_openBlock(), _createBlock("li", { key: coIndex }, [
                                _createVNode("div", _hoisted_89, [
                                  _withDirectives(_createVNode("input", {
                                    class: "custom-control-input",
                                    id: 'customCheck2' + coIndex,
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => (co.isChecked = $event),
                                    value: co.user.id
                                  }, null, 8, ["id", "onUpdate:modelValue", "value"]), [
                                    [_vModelCheckbox, co.isChecked]
                                  ]),
                                  _createVNode("label", {
                                    class: "custom-control-label",
                                    for: 'customCheck2' + coIndex
                                  }, _toDisplayString(co.user.full_name) + " (" + _toDisplayString(co.user.email) + ")", 9, ["for"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_90, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createChannel && _ctx.createChannel(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.createChannel
                    ? _ctx.$t('creating')
                    : _ctx.$t('create_channel')), 1)
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.data.showCreateChannel]
      ]),
      _withDirectives(_createVNode("div", _hoisted_91, [
        _createVNode("div", _hoisted_92, [
          _createVNode("div", _hoisted_93, [
            _createVNode("div", _hoisted_94, [
              _createVNode("div", _hoisted_95, [
                _createVNode("h5", _hoisted_96, _toDisplayString(_ctx.$t('edit')) + " : " + _toDisplayString(_ctx.state.data.selectedProject.name), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hideRenameProjectModal && _ctx.hideRenameProjectModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_97
                ])
              ]),
              _createVNode("div", _hoisted_98, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.error.errorList,
                  hasError: _ctx.state.ui.error.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                _createVNode("p", _hoisted_99, [
                  _createTextVNode(_toDisplayString(_ctx.$t('note')) + " " + _toDisplayString(_ctx.$t('fields_marked_with')) + " ", 1),
                  _hoisted_100,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('are_mandatory')), 1)
                ]),
                _createVNode("div", _hoisted_101, [
                  _createVNode("label", _hoisted_102, [
                    _createTextVNode(_toDisplayString(_ctx.$t('project_name')) + " ", 1),
                    _hoisted_103
                  ]),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "exampleInputEmail1",
                    "aria-describedby": "emailHelp",
                    placeholder: _ctx.$t('project_name_placeholder'),
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.selectedProjectEdit.projectName = $event))
                  }, null, 8, ["placeholder"]), [
                    [_vModelText, _ctx.state.data.selectedProjectEdit.projectName]
                  ])
                ]),
                _createVNode("div", _hoisted_104, [
                  _createVNode("label", _hoisted_105, _toDisplayString(_ctx.$t('project_description')), 1),
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    name: "",
                    id: "",
                    cols: "30",
                    rows: "10",
                    placeholder: _ctx.$t('project_description_placeholder'),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.selectedProjectEdit.projectDescription = $event))
                  }, null, 8, ["placeholder"]), [
                    [_vModelText, _ctx.state.data.selectedProjectEdit.projectDescription]
                  ])
                ]),
                _createVNode("div", _hoisted_106, [
                  _createVNode("label", _hoisted_107, _toDisplayString(_ctx.$t('project_tags')), 1),
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedOptions,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedOptions = $event)),
                    "tag-placeholder": "Add this as new tag",
                    placeholder: _ctx.$t('project_tags_placeholder'),
                    label: "name",
                    "track-by": "code",
                    options: _ctx.options,
                    multiple: true,
                    taggable: true,
                    onTag: _ctx.addTag
                  }, null, 8, ["modelValue", "placeholder", "options", "onTag"])
                ]),
                _createVNode("div", _hoisted_108, [
                  _createVNode("label", _hoisted_109, _toDisplayString(_ctx.$t('project_address')), 1),
                  _createVNode(_component_GoogleMapView, {
                    latitude: _ctx.latitude,
                    longitude: _ctx.longitude,
                    address: _ctx.address,
                    isEdit: true,
                    "onUpdate:latitude": _ctx.updateLatitude,
                    "onUpdate:longitude": _ctx.updateLongitude,
                    "onUpdate:address": _ctx.updateAddress,
                    key: _ctx.latitude
                  }, null, 8, ["latitude", "longitude", "address", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:address"])
                ])
              ]),
              _createVNode("div", _hoisted_110, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.saveEditProject && _ctx.saveEditProject(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.saveEditProject
                    ? _ctx.$t('loading1')
                    : _ctx.$t('save_changes')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.hideRenameProjectModal && _ctx.hideRenameProjectModal(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.data.showRenameModal]
      ]),
      _createVNode("div", _hoisted_111, [
        _createVNode("div", _hoisted_112, [
          _createVNode("div", _hoisted_113, [
            _createVNode("div", _hoisted_114, [
              _createVNode("div", _hoisted_115, [
                _createVNode("h5", _hoisted_116, _toDisplayString(_ctx.$t('project_archive')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeProjectArchiveModal && _ctx.closeProjectArchiveModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_117
                ])
              ]),
              _createVNode("div", _hoisted_118, [
                _createVNode("div", _hoisted_119, _toDisplayString(_ctx.$t('archive_project_confirmation')), 1)
              ]),
              _createVNode("div", _hoisted_120, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.projectArchive && _ctx.projectArchive(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.projectArchive ? _ctx.$t('loading1') : _ctx.$t('archive')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeProjectArchiveModal && _ctx.closeProjectArchiveModal(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_121, [
        _createVNode("div", _hoisted_122, [
          _createVNode("div", _hoisted_123, [
            _createVNode("div", _hoisted_124, [
              _createVNode("div", _hoisted_125, [
                _createVNode("h5", _hoisted_126, _toDisplayString(_ctx.$t('project_restore')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeProjectRestoreModal && _ctx.closeProjectRestoreModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_127
                ])
              ]),
              _createVNode("div", _hoisted_128, [
                _createVNode("div", _hoisted_129, _toDisplayString(_ctx.$t('restore_project_confirmation')), 1)
              ]),
              _createVNode("div", _hoisted_130, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.projectRestore && _ctx.projectRestore(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.projectArchive ? _ctx.$t('loading1') : _ctx.$t('restore')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeProjectRestoreModal && _ctx.closeProjectRestoreModal(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ]),
      _withDirectives(_createVNode("div", _hoisted_131, [
        _createVNode("div", _hoisted_132, [
          _createVNode("div", _hoisted_133, [
            _createVNode("div", _hoisted_134, [
              _createVNode("div", _hoisted_135, [
                _createVNode("h5", _hoisted_136, _toDisplayString(_ctx.$t('pin_to_top')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectClose && _ctx.addFavProjectClose(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_137
                ])
              ]),
              _createVNode("div", _hoisted_138, [
                _createVNode("div", _hoisted_139, _toDisplayString(_ctx.$t('pin_confirmation')), 1)
              ]),
              _createVNode("div", _hoisted_140, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.projectFav && _ctx.projectFav(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.projectFav ? "loading..." : "Yes"), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectClose && _ctx.addFavProjectClose(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.data.showAddFavProjectModal ]
      ]),
      _withDirectives(_createVNode("div", _hoisted_141, [
        _createVNode("div", _hoisted_142, [
          _createVNode("div", _hoisted_143, [
            _createVNode("div", _hoisted_144, [
              _createVNode("div", _hoisted_145, [
                _createVNode("h5", _hoisted_146, _toDisplayString(_ctx.$t('unpin_project')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectClose && _ctx.removeFavProjectClose(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_147
                ])
              ]),
              _createVNode("div", _hoisted_148, [
                _createVNode("div", _hoisted_149, _toDisplayString(_ctx.$t('unpin_confirmation')), 1)
              ]),
              _createVNode("div", _hoisted_150, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.projectFavRemove && _ctx.projectFavRemove(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.projectFavRemove ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectClose && _ctx.removeFavProjectClose(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.data.showRemoveFavProjectModal]
      ]),
      _withDirectives(_createVNode("div", _hoisted_151, [
        _createVNode("div", _hoisted_152, [
          _createVNode("div", _hoisted_153, [
            _createVNode("div", _hoisted_154, [
              _createVNode("div", _hoisted_155, [
                _createVNode("h5", _hoisted_156, _toDisplayString(_ctx.$t('hide_project')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.hideProjectClose && _ctx.hideProjectClose(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_157
                ])
              ]),
              _createVNode("div", _hoisted_158, [
                _createVNode("div", _hoisted_159, _toDisplayString(_ctx.$t('hide_confirmation')), 1)
              ]),
              _createVNode("div", _hoisted_160, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.projectHide && _ctx.projectHide(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.projectHide ? _ctx.$t('hide_confirmation') : _ctx.$t('yes')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.hideProjectShow && _ctx.hideProjectShow(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.data.showHideProjectModal]
      ]),
      _withDirectives(_createVNode("div", _hoisted_161, [
        _createVNode("div", _hoisted_162, [
          _createVNode("div", _hoisted_163, [
            _createVNode("div", _hoisted_164, [
              _createVNode("div", _hoisted_165, [
                _createVNode("h5", _hoisted_166, _toDisplayString(_ctx.$t('unhide_project')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.showProjectClose && _ctx.showProjectClose(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_167
                ])
              ]),
              _createVNode("div", _hoisted_168, [
                _createVNode("div", _hoisted_169, _toDisplayString(_ctx.$t('unhide_confirmation')), 1)
              ]),
              _createVNode("div", _hoisted_170, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.projectShow && _ctx.projectShow(...args)))
                }, _toDisplayString(_ctx.state.ui.postLoading.projectShow ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.showProjectClose && _ctx.showProjectClose(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.state.data.showProjectModal]
      ]),
      _createVNode("div", _hoisted_171, [
        _createVNode("div", _hoisted_172, [
          _createVNode("div", _hoisted_173, [
            _createVNode("div", _hoisted_174, [
              _createVNode("div", _hoisted_175, [
                _createVNode("h5", _hoisted_176, _toDisplayString(_ctx.$t('location_for')) + " " + _toDisplayString(_ctx.state.data.selectedProjectMap.name), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.hideProjectLocation && _ctx.hideProjectLocation(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_177
                ])
              ]),
              _createVNode("div", _hoisted_178, [
                _createVNode(_component_GoogleMap, {
                  latitude: _ctx.state.data.selectedProjectMap.latitude,
                  longitude: _ctx.state.data.selectedProjectMap.longitude,
                  address: _ctx.state.data.selectedProjectMap.full_address,
                  visible: true,
                  key: _ctx.state.data.selectedProjectMap.id
                }, null, 8, ["latitude", "longitude", "address"])
              ]),
              _createVNode("div", _hoisted_179, [
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.hideProjectLocation && _ctx.hideProjectLocation(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showMemberListModal)
      ? (_openBlock(), _createBlock(_component_ShowMemberListModal, {
          key: 1,
          showModal: _ctx.state.data.showMemberListModal,
          members: _ctx.state.membersList,
          projectRoleCodes: [_ctx.state.currentProjectRoleCode],
          onClose: _ctx.hideMemberListModal
        }, null, 8, ["showModal", "members", "projectRoleCodes", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}